"use client";

import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

type AdminLoadingStateProps = {
  label?: string;
  className?: string;
  icon?: ReactNode;
};

export function AdminLoadingState({
  label,
  className,
  icon,
}: AdminLoadingStateProps) {
  const { t } = useTranslation("admin");

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-center",
        className,
      )}
    >
      {icon ?? (
        <Loader2 className="size-8 animate-spin text-primary" aria-hidden />
      )}
      <p className="text-sm text-muted-foreground">
        {label ??
          t("components.loading.label", { defaultValue: "Loading…" })}
      </p>
    </div>
  );
}
